import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueGtag from "vue-gtag";
import "./index.css";
Vue.config.productionTip = false;
Vue.use(VueGtag, {
    config: { id: "G-C28J0BTR0J" },
    params: {
        // eslint-disable-next-line @typescript-eslint/camelcase
        send_page_view: false
    }
});
new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
